<template>
  <form-render v-if="fields && fields.length > 0" :form.sync="form" :fields="fields" @send="onAccept" :key="keyFormRender"
    containerButtonsClass="col-12 d-flex justify-content-end">
    <template #buttonsGroupSlot>
      <b-button variant="warning" type="submit" :disabled="loading">{{ nameButton }}</b-button>
    </template>
    <template #warehouseSlot>
      <label>Bodega *</label>
      <b-form-select placeholder="Selecciona una bodega" v-model="form.warehouse" :options="optionWarehouse" @change="changeWarehouse">
        <template #first>
          <b-form-select-option value="empty">Elige una dirección diferente</b-form-select-option>
        </template>
      </b-form-select>
    </template>
  </form-render>
</template>

<script>
export default {
  props: ['extraField', 'masterData', 'ticket', 'delivery', 'deliveryId', 'options', 'activateFormRender', 'dataOrganized'],
  data() {
    return {
      form: {},
      fields: [],
      keyFormRender: 0
    }
  },
  watch: {
    'extraField': {
      handler(value) {
        this.setFormExtraFields(value)
      }
    },
    'activateFormRender': {
      handler() {
        this.keyFormRender++
      }
    }
  },
  computed: {
    loading() {
      return !!this.options?.loading
    },
    optionWarehouse() {
      return this.masterData.warehouse?.map(element => ({
        ...element,
        value: element.id ?? element.identifier ?? element.code,
        text: element.text ?? element.name
      })) || []
    },
    nameButton() {
      return this.options?.nameButton || 'Confirmar'
    },
    country() {
      return this.ticket?.carrier?.country || this.masterData?.defaults?.country || 'CL'
    },
    fullAddress() {
      return this.ticket?.delivery?.destination?.full_address || this.delivery?.address?.full_address || this.masterData?.defaults?.full_address || ''
    },
    placeId() {
      return this.ticket?.delivery?.destination?.place_id || this.delivery?.destination?.place_id || this.delivery?.place_id || this.masterData?.defaults?.place_id || null
    },
    warehouseTicket() {
      return this.ticket?.delivery?.origin?.warehouse_id || this.masterData?.defaults?.warehouse?.identifier || null
    },
    phoneDelivery() {
      return this.delivery?.phone || null
    },
    deliveryIdForm() {
      return this.ticket?.delivery?.id || this.delivery?.id || this.deliveryId
    }
  },
  methods: {
    changeDisableStatus(name, status = false) {
      const field = this.fields.find(el => el.name === name)
      if (field) field.disabled = status
    },
    changeWarehouse(value) {
      const warehouse = value !== 'empty' ? this.warehouseSelect(value) : null
      if (warehouse) {
        Object.assign(this.form, {
          place: this.setPlace(warehouse?.address?.place_id),
          full_address: warehouse?.address?.full_address,
          warehouse_contact_phone: warehouse?.contact_phone,
          warehouse_contact_name: warehouse?.contact_name
        })
        this.changeDisableStatus('place', true)
        this.changeDisableStatus('full_address', true)
      } else {
        Object.assign(this.form, { place: {}, full_address: '', warehouse_contact_name: '', warehouse_contact_phone: '' })
        this.changeDisableStatus('place', false)
        this.changeDisableStatus('full_address', false)
      }
      this.keyFormRender++
    },
    setFormExtraFields(value) {
      this.fields = []
      this.form = {}
      if (!!(value?.extra_fields && value.extra_fields.length > 0)) {
        const countrySelect = this.masterData?.countries?.find(el => el.code === this.country)
        value.extra_fields.forEach(field => {
          if (field.max_length) field.max = field.maxLength = field.max_length
          const commonProps = { fieldType: 'FieldInput', containerClass: 'col-sm-12 container-info' }
          switch (field.type) {
          case 'string':
          case 'text':
            if (field.name === 'warehouse_contact_name') {
              field.capitalize = true
              field.max = 25
            }
            if (field.name === 'value_to_claim') field.append = {text:  countrySelect && countrySelect.currency ? countrySelect.currency : 'Peso Chileno'}
            this.fields.push({ ...field, ...commonProps, type: 'text' })
            break
          case 'phone':
            if (countrySelect) {
              if (countrySelect.mask_number) field.mask = countrySelect.mask_number
              if (countrySelect.phone_code) field.prepend = { text: `+${countrySelect.phone_code}` }
            }
            this.fields.push({ ...field, ...commonProps, type: 'tel', clearable: true })
            break
          case 'place': {
            const optionsArray = this.setOptionsArrayPlaces(field?.options ?? this.masterData[field.name])
            console.log(countrySelect)
            if (field.disabled === true) {
              field.validation = ''
              this.fields.push({...field, fieldType: 'FieldSelect', containerClass: 'col-sm-12 container-info',
                options: optionsArray})
            } else if (optionsArray.length === 0) {
              this.fields.push({...field, fieldType: 'FieldSelect', containerClass: 'col-sm-12 container-info',
                options: optionsArray, searchOnType: {fx: this.searchPlace, nChars: 3}})
            } else {
              this.fields.push({...field, fieldType: 'FieldSelect', containerClass: 'col-sm-12 container-info',
                options: optionsArray})
            }
            break
          }
          case 'selector':
          case 'array': {
            const optionsArray = this.setOptionsArray(field?.options ?? this.masterData[field.name])
            if (field.disabled === true) {
              field.validation = ''
              this.fields.push({...field, fieldType: 'FieldSelect', containerClass: 'col-sm-12 container-info',
                options: optionsArray})
            } else {
              this.fields.push({...field, fieldType: 'FieldSelect', containerClass: 'col-sm-12 container-info',
                options: optionsArray})
            }
            break
          }
          case 'warehouse': {
            this.fields.push({name:'warehouseSlot', useSlot: true, containerClass: 'col-sm-12 container-info'})
            break
          }
          case 'file':
            this.fields.push({ ...field, fieldType: 'FieldFile', containerClass: 'col-sm-12 container-info', multiple: !field.unique })
            break
          case 'file_picker': {
            const optionFilePicker = this.setFileOptions(field)
            this.fields.push(
              { ...field, fieldType: 'FieldSelect', name: `${field.name}Select`, containerClass: 'col-sm-12 container-info', options: optionFilePicker },
              { ...field, fieldType: 'FieldFile', name: `${field.name}File`, label: '', containerClass: 'col-sm-12 container-info', multiple: !field.unique }
            )
            break }
          case 'textarea':
            this.fields.push({ ...field, fieldType: 'FieldTextarea', containerClass: 'col-sm-12 container-info' })
            break
          case 'number':
            if (field.name === 'price' || field.name === 'value_to_claim') {
              this.fields.push({...field, ...commonProps, type: 'number', append: {text:  countrySelect && countrySelect.currency ? countrySelect.currency : 'Peso Chileno'}})
            } else {
              this.fields.push({...field, ...commonProps, type: 'number'})
            }
            break
          default:
            this.fields.push({ ...field, ...commonProps, type: 'text' })
            break
          }
        })
      } else {
        this.fields.push({ fieldType: 'FieldTextarea', type: 'textarea', name: 'description', label: 'Descripción', containerClass: 'col-sm-12 container-info', validation: 'optional', disabled: false, placeholder: 'Descripción' })
      }
      this.fields.push({ name: 'buttonsGroupSlot', useSlot: true, containerClass: 'col-12 p-0 d-flex justify-content-end' })
      this.setArrangementsField(value)
    },
    setArrangementsField(value) {
      this.fields.forEach(field => {
        if (value.code === 'RETRY') {
          if (field.name === 'full_address') this.form.full_address = this.fullAddress
          if (field.name === 'place') this.form.place = this.setPlace()
        } else if (value.code === 'CHANGE_ADDRESS') {
          if (field.name === 'place') {
            this.form.place = this.setPlace()
            this.form.full_address = this.fullAddress
            this.form.phone = this.phoneDelivery
          }
        } else if (value.code === 'RETURN') {
          if (['warehouse', 'warehouseSlot'].includes(field.name)) {
            this.form.warehouse = this.warehouseTicket
            this.changeWarehouse(this.form.warehouse)
          }
          if (['place', 'full_address'].includes(field.name)) field.disabled = true
        }
      })
      this.keyFormRender++
    },
    setFileOptions (val) {
      return val.attachment_types.map(element => ({id: element.type, text: element.name }))
    },
    setOptionsArray (optionsArray) {
      return optionsArray ? optionsArray.map(element => ({
        ...element,
        id: element.id ?? element.identifier ?? element.code,
        value: element.value ?? element.id ?? element.identifier ?? element.code,
        text: element.text ?? element.name
      })) : []
    },
    setPlace(idPlace = null) {
      return this.masterData?.place?.find(el => el.id === (idPlace || this.placeId)) || {}
    },
    createMessage(extraFields, labelExtraFields) {
      let message = ''
      const exceptions = ['place', 'invoiceFile', 'invoiceSelect', 'warehouse', 'product', 'warehouseSlot']
      if (this.form.warehouse) {
        const warehouse = this.warehouseSelect(this.form.warehouse)
        if (warehouse) {
          message += `Bodega: ${warehouse.name} \n`
        }
      }
      for (const key in extraFields) {
        if (Object.hasOwnProperty.call(extraFields, key)) {
          const objectLabel = labelExtraFields.find(el => el.name === key)
          if (objectLabel) {
            if (!exceptions.includes(key) && objectLabel.label && extraFields[key]) {
              message += `${objectLabel.label}: ${extraFields[key]} \n`
            } else if (key === 'invoiceSelect') {
              message += `${objectLabel.label}: ${extraFields[key].text} \n`
            } else if (key === 'place') {
              const places = extraFields[key].value
              for (const placeKey in places) {
                if (places[placeKey]?.label && places[placeKey]?.value) {
                  message += `${places[placeKey].label}: ${places[placeKey].value} \n`
                }
              }
            }
          }
        }
      }
      return message || this.message
    },
    setExtraFieldsForm(selectType, data) {
      const formReturn = {
        extra_fields: {},
        fileToSend: []
      }
      let objectLabel = {}
      if (selectType.extra_fields && selectType.extra_fields.length > 0) {
        selectType.extra_fields.forEach(el => {
          switch (el.type) {

          case 'file_picker':
            if (data && data[`${el.name}File`]) {
              formReturn.fileToSend = [...formReturn.fileToSend, {
                'queryParams': {
                  'attachment_type_code': data[`${el.name}Select`].id.toUpperCase(),
                  'confirm_summary': true,
                  'send_message': 1,
                  'price': data[`${el.attachment_extra_fields.price}`],
                  'delivery_id': this.deliveryIdForm
                },
                'files': data[`${el.name}File`]
              }]
            }
            break
          case 'file':
            if (data[el.name]) {
              formReturn.fileToSend = [...formReturn.fileToSend, {
                'queryParams': {
                  'attachment_type_code': el.name.toUpperCase(),
                  'confirm_summary': true,
                  'send_message': 1,
                  'delivery_id': this.deliveryIdForm
                },
                'files': data[el.name]
              }]
            }
            break
          case 'place':
            objectLabel = this.objectField(el)
            if (el.disabled === true) {
              formReturn.extra_fields[el.name] = {
                value: data[el.name] && data[el.name].value ? data[el.name].value : this.ticket?.delivery?.origin?.place_id,
                label: objectLabel['label'] ?? ''
              }
            } else {
              formReturn.extra_fields[el.name] = {
                value: data[el.name] && data[el.name].id ? data[el.name].value : data[el.name],
                label: objectLabel['label'] ?? ''
              }
            }
            break
          case 'warehouse':
            formReturn.extra_fields.warehouse = {
              value: this.warehouseSelect(data.warehouse)?.name,
              label: 'Bodega'
            }
            break
          case 'phone':
            objectLabel = this.objectField(el)
            formReturn.extra_fields[objectLabel.name] = {value: data[objectLabel.name].replace(/\s/g, ''), label:  objectLabel['label'] ?? ''}
            break
          default:
            objectLabel = this.objectField(el)
            formReturn.extra_fields[el.name] = {
              value: data[el.name] && data[el.name].id ? data[el.name].id : data[el.name],
              label: objectLabel?.label ?? ''
            }
            break
          }
        })
      } else {
        formReturn.extra_fields = {
          description: this.form.description
        }
      }
      return formReturn
    },
    objectField(el) {
      return this.fields.filter(element => element.name === el.name)[0]
    },
    onAccept() {
      const dataEmit = {
        extra_fields: {
          form: { ...this.form },
          data_organized: this.ticket || this.dataOrganized ? this.setExtraFieldsForm(this.extraField, this.form) : {},
          message: this.createMessage(this.form, this.fields)
        },
        ticket_type_code: this.extraField
      }
      if (this.form.warehouse) {
        dataEmit.extra_fields.form.warehouse = this.warehouseSelect(this.form.warehouse)
        dataEmit.extra_fields.form = this.warehouseForm(dataEmit.extra_fields.form)
      }
      this.$emit('updateExtraField', dataEmit)
    },
    warehouseSelect(value) {
      const warehouse = this.optionWarehouse.find(el => el.value === value)
      return warehouse ?? {
        name: 'Bodega diferente'
      }
    },
    warehouseForm(value) {
      if (this.form?.warehouse_contact_phone) value.warehouse_contact_phone = this.form?.warehouse_contact_phone
      if (this.form?.warehouse_contact_name) value.warehouse_contact_name = this.form?.warehouse_contact_name
      return value
    }
  }
}
</script>
